import { Outlet } from "react-router";
import { Page } from "@goodfill/ui-components";
import { Footer } from "./common/Footer";
import { useLocation } from "react-router-dom";
import { route } from "../routes";

export const Layout = () => {
  const location = useLocation();

  const noFooterPages = [
    route.dashboard(), // There is virtualized scroll of bonds on the main page
  ];

  return (
    <Page>
      <Outlet />
      {!noFooterPages.includes(location.pathname) ? <Footer /> : null}
    </Page>
  );
};
